import Component from 'flarum/common/Component';
import Link from 'flarum/common/components/Link';

/**
 * Visible "Forum > [Group] > [Primary] > [Secondary]" trail. Attrs:
 *   - group: { slug, label } | null
 *   - primary: Tag model | null
 *   - primaryIcon: asset URL | null - the primary board's own model-line
 *     icon (resolved by the caller, which already has the presentation
 *     lookup/forumAssetUrl helper), shown before the leading "Forum" crumb
 *     (2026-09-06, user call: reads as orientation for the whole trail
 *     better there than tucked next to the current-page crumb it's
 *     furthest from). Boards with no registered presentation
 *     (General/Bus/Truck) pass null and render text-only, same as before
 *     this existed.
 *   - primaryLabel: string | null - text for the primary crumb. Normally
 *     just the tag's own name, but the caller may pass a longer
 *     "familyName" from the presentation registry instead (2026-09-07,
 *     first real case: primary tag name is the short "N/P", but the
 *     breadcrumb reads better with "Belphégor" - see
 *     modelLinePresentation.js's own comment on that entry for why this is
 *     a deliberate, scoped exception, not the default for every line).
 *   - secondary: Tag model | null
 * Every level except the current page's own is a real link (not
 * decorative), matching the same URLs app.route.tag()/the breadcrumb
 * driver resolve to.
 */
export default class TaxonomyBreadcrumb extends Component {
  view() {
    const { group, primary, primaryIcon, primaryLabel, secondary } = this.attrs;

    const crumbs = [{ label: 'Forum', href: app.route('index'), icon: primaryIcon }];

    if (group) {
      crumbs.push({ label: group.label, href: app.route(`citreg.group.${group.slug}`) });
    }

    if (primary) {
      crumbs.push({ label: primaryLabel || primary.name(), href: app.route.tag(primary) });
    }

    if (secondary) {
      crumbs.push({ label: secondary.name(), href: null });
    }

    return (
      <nav className="TaxonomyBreadcrumb" aria-label="Breadcrumb">
        {crumbs.map((crumb, index) => {
          const isLast = index === crumbs.length - 1;
          const content = [
            crumb.icon && <img className="TaxonomyBreadcrumb-icon" src={crumb.icon} alt="" />,
            crumb.label,
          ];

          return [
            index > 0 && <span className="TaxonomyBreadcrumb-separator">{'›'}</span>,
            isLast || !crumb.href ? (
              <span className="TaxonomyBreadcrumb-current">{content}</span>
            ) : (
              <Link href={crumb.href}>{content}</Link>
            ),
          ];
        })}
      </nav>
    );
  }
}
